"use strict";

exports.__esModule = true;
exports.default = getRoundedValueAndDataLabelUnits;
var NUMBER_OF_DIGITS_TO_SHOW = 3;
var ONE_BILLION = 1e9;
var ONE_MILLION = 1e6;
var ONE_THOUSAND = 1000;
var ONE_TRILLION = 1e12;

function getRoundedValueAndDataLabelUnits(value) {
  var absValue = Math.abs(Math.round(value));
  var preciseValue = parseFloat(absValue.toPrecision(NUMBER_OF_DIGITS_TO_SHOW));
  var roundedValue = preciseValue;
  var dataLabelUnits = '';

  if (preciseValue >= ONE_TRILLION) {
    roundedValue = preciseValue / ONE_TRILLION;
    dataLabelUnits = 'T';
  } else if (preciseValue >= ONE_BILLION) {
    roundedValue = preciseValue / ONE_BILLION;
    dataLabelUnits = 'B';
  } else if (preciseValue >= ONE_MILLION) {
    roundedValue = preciseValue / ONE_MILLION;
    dataLabelUnits = 'M';
  } else if (preciseValue >= ONE_THOUSAND) {
    roundedValue = preciseValue / ONE_THOUSAND;
    dataLabelUnits = 'k';
  }

  return {
    roundedValue: roundedValue,
    dataLabelUnits: dataLabelUnits
  };
}